import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VSNTypography from "../../shared/VSNTypography";
import { LearningAdminContainer } from "../../container/learningAdmin.container";
import VSNModel from "../../shared/VSNModel";
import LearningSectionModal from "./LearningSectionModal";
import VSNLoader from "../../shared/VSNLoader";
import { LearningStyle } from "./LearningStyle";
import VSNBreadcrumbs from "../../shared/VSNBreadcrumbs";

const LearningAdmin = () => {
  const navigate = useNavigate();
  const classes = LearningStyle();
  const {
    loader,
    learningContentGetData,
    learningContentListData,
    handleChange,
    handleMobileChange,
    handleCreateEventSchedule,
    createEventScheduleAttribute,
    handleClose,
    selectedRow,
    openModal,
    setOpenModal,
    selectedDropdown,
    onChangeCourse,
    handleIconClick,
    loaderAction,
    setSelectedRow,
  } = LearningAdminContainer();

  const allSelectedCourseIds = learningContentGetData
    ?.map((row, idx) => {
      const isBanner = row?.course_id !== undefined;
      if (!isBanner) return null;
      return selectedDropdown[row?.banner_id] ?? row?.course_id ?? null;
    })
    ?.filter((id) => id !== null);

  const breadcrumbsRoutes = [
    {
      path: "/learning?fromTo=learningAdmin",
      label: "Learning",
    },
    {
      label: "Learning Admin",
    },
  ];

  if (loader) {
    return <VSNLoader variant="transParent" />;
  }
  return (
    <Box className={classes.mainLayout}>
      <Box>
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          py={2}
          px={{ sm: 4, xs: 2 }}
        >
          <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
        </Stack>
      </Box>

      <Box py={1} px={{ sm: 4, xs: 2 }}>
        <TableContainer
          sx={{
            backgroundColor: "#fff",
            boxShadow: "0px 7.7982px 17.32934px 0px rgba(81, 125, 132, 0.07)",
            borderRadius: "8px",
            padding: "0px 30px",
          }}
        >
          <Table>
            <TableHead
              sx={{
                "& .MuiTableCell-root": {
                  padding: "16px 10px",
                },
              }}
            >
              <TableRow>
                <TableCell width="25%">
                  <VSNTypography fontWeight="500">
                    Main Section Name
                  </VSNTypography>
                </TableCell>
                <TableCell width="25%">
                  <VSNTypography fontWeight="500">Description</VSNTypography>
                </TableCell>
                <TableCell width="40%">
                  <VSNTypography fontWeight="500">Courses</VSNTypography>
                </TableCell>
                <TableCell width="10%">
                  <VSNTypography fontWeight="500">Action</VSNTypography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  border: 0,
                  padding: "10px",
                },
              }}
            >
              {learningContentGetData?.length > 0 ? (
                learningContentGetData?.map((item, index) => {
                  const isBanner = item?.course_id !== undefined;
                  const isSection = item?.courses !== undefined;

                  const keyForState = item.banner_id
                    ? `banner_${item.banner_id}`
                    : `noBanner_${index}`;

                  const dropdownValue =
                    selectedDropdown[keyForState] ?? item.course_id ?? "";

                  return (
                    <TableRow key={`content-list-${index}`}>
                      <TableCell>
                        <VSNTypography>{item?.main_section_name}</VSNTypography>
                      </TableCell>

                      <TableCell>
                        <VSNTypography>
                          {item?.section_name || item?.section_title || "-"}
                        </VSNTypography>
                      </TableCell>

                      <TableCell>
                        {isBanner ? (
                          <Select
                            sx={{
                              minWidth: "400px",
                              maxHeight: "45px",
                              borderRadius: "4px",
                            }}
                            value={dropdownValue}
                            onChange={(e) =>
                              onChangeCourse(
                                e.target.value,
                                item,
                                index,
                                keyForState
                              )
                            }
                            displayEmpty
                          >
                            <MenuItem disabled value="">
                              Select a course
                            </MenuItem>
                            {learningContentListData?.map((option, optIdx) => {
                              const isSelectedElsewhere =
                                allSelectedCourseIds.includes(option.id) &&
                                option.id !== dropdownValue;

                              return (
                                <MenuItem
                                  key={`content-courses-${optIdx}`}
                                  value={option.id}
                                  disabled={isSelectedElsewhere}
                                >
                                  {option.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        ) : (
                          <VSNTypography>{item.section_title}</VSNTypography>
                        )}
                      </TableCell>

                      {isSection && (
                        <TableCell>
                          <IconButton onClick={() => handleIconClick(item)}>
                            <EditIcon color="primary" />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell colSpan={4} align="center">
                  <CircularProgress size={24} color="inherit" />
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {openModal && (
        <VSNModel
          open={openModal}
          onClose={() => setOpenModal(false)}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
        >
          <LearningSectionModal
            handleCreateEventSchedule={handleCreateEventSchedule}
            handleChange={handleChange}
            handleMobileChange={handleMobileChange}
            createEventScheduleAttribute={createEventScheduleAttribute}
            selectedRow={selectedRow}
            handleClose={handleClose}
            loaderAction={loaderAction}
            openModal={openModal}
            setSelectedRow={setSelectedRow}
          />
        </VSNModel>
      )}
    </Box>
  );
};

export default LearningAdmin;
